import translations from './languages/languages';

export default class Translator {
  constructor() {
    this.currentLanguage = null;
  }

  setLanguage(language) {
    this.currentLanguage = language;
    const element = document.getElementById('blockly_language_script');
    if (element) {
      element.parentElement.removeChild(element);
    }
  }

  getLanguage() {
    return this.currentLanguage;
  }

  updateUI() {
    const elements = document.querySelectorAll('[data-translate]');
    if (!elements.length) {
      return;
    }

    for (let i = 0; i < elements.length; i++) {
      const key = elements[i].dataset.translate;
      if (elements[i].nodeName === 'INPUT') {
        elements[i].value = this.translate(key);
      } else {
        elements[i].innerHTML = this.translate(key);
      }
    }
  }

  translate(key) {
    if (key in translations[this.currentLanguage]) {
      return translations[this.currentLanguage][key];
    }

    console.warn(`Translation key was not found: ${key} in lang ${this.currentLanguage}`);
    return '';
  }

  t(key) {
    return this.translate(key);
  }

  static languages() {
    return Object.keys(translations);
  }
}
